export default "__VITE_ASSET__D813eB9p__"